
import Page from './component';
import KEY from './const';

export default [
    {
        Page,
        KEY
    }
];

